export default {
  path: '/product-storage',
  name: 'product-storage',
  component: () => import('@/views/product-storage/Index'),
  redirect: { name: 'suppliers-index' },
  children: [
    {
      path: 'suppliers',
      name: 'suppliers-index',
      component: () => import('@/views/product-storage/suppliers/Index'),
      redirect: { name: 'suppliers-list' },
      children: [
        {
          path: '',
          name: 'suppliers-list',
          component: () => import('@/views/product-storage/suppliers/List'),
          meta: {
            title: 'List of suppliers',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
        {
          path: ':id',
          name: 'supplier-detail',
          component: () => import('@/views/product-storage/suppliers/Detail'),
          meta: {
            title: 'Supplier (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        }
      ]
    },
    {
      path: 'orders',
      component: () => import('@/views/product-storage/orders/Index'),
      children: [
        {
          path: '',
          name: 'product-storage-orders',
          component: () => import('@/views/product-storage/orders/Layout'),
          redirect: { name: 'product-storage-orders-active' },
          children: [
            {
              path: '',
              name: 'product-storage-orders-active',
              component: () => import('@/views/product-storage/orders/Active'),
              meta: {
                title: 'List of orders',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
              }
            },
            {
              path: 'completed',
              name: 'product-storage-orders-completed',
              component: () => import('@/views/product-storage/orders/Completed'),
              meta: {
                title: 'List of orders',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
              }
            },
          ],
        },
        {
          path: ':id',
          name: 'product-storage-order-detail',
          component: () => import('@/views/product-storage/orders/Detail'),
          meta: {
            title: 'Order (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
      ]
    },
    {
      path: 'transfers',
      component: () => import('@/views/product-storage/transfers/Index'),
      children: [
        {
          path: '',
          name: 'product-storage-transfers',
          component: () => import('@/views/product-storage/transfers/Layout'),
          redirect: { name: 'product-storage-transfers-active' },
          children: [
            {
              path: '',
              name: 'product-storage-transfers-active',
              component: () => import('@/views/product-storage/transfers/Active'),
              meta: {
                title: 'List of transfers',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
              }
            },
            {
              path: 'completed',
              name: 'product-storage-transfers-completed',
              component: () => import('@/views/product-storage/transfers/Completed'),
              meta: {
                title: 'List of transfers',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
              }
            },
          ],
        },
        {
          path: ':id',
          name: 'product-storage-transfer-detail',
          component: () => import('@/views/product-storage/transfers/Detail'),
          meta: {
            title: 'Transfer (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
      ]
    },
    {
      path: 'products',
      component: () => import('@/views/product-storage/products/Index'),
      children: [
        {
          path: '',
          name: 'product-storage-products-list',
          component: () => import('@/views/product-storage/products/List'),
          meta: {
            title: 'List of products',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
        {
          path: ':id',
          name: 'product-storage-products-detail',
          component: () => import('@/views/product-storage/products/Detail'),
          meta: {
            title: 'Product (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
      ]
    },
    {
      path: 'stocktaking',
      component: () => import('@/views/product-storage/stocktaking/Index'),
      children: [
        {
          path: '',
          name: 'product-storage-stocktaking-list',
          component: () => import('@/views/product-storage/stocktaking/List'),
          meta: {
            title: 'Stocktaking\'s',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
        {
          path: ':id',
          name: 'product-storage-stocktaking-detail',
          component: () => import('@/views/product-storage/stocktaking/Detail'),
          meta: {
            title: 'Stocktaking (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
      ],
    },
    {
      path: 'cash-requests-orders',
      component: () => import('@/views/product-storage/cash-requests/Index'),
      children: [
        {
          path: '',
          component: () => import('@/views/product-storage/cash-requests/Layout'),
          children: [
            {
              path: '',
              name: 'product-storage-cash-active',
              component: () => import('@/views/product-storage/cash-requests/Active'),
              meta: {
                title: 'List of cash requests for orders',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
              }
            },
            {
              path: 'completed',
              name: 'product-storage-cash-completed',
              component: () => import('@/views/product-storage/cash-requests/Completed'),
              meta: {
                title: 'List of cash requests for orders',
                roles: ['general_manager', 'product_storage_manager', 'product_storage_supervisor']
              }
            },
          ],
        },
        {
          path: ':id',
          name: 'product-storage-cash-detail',
          component: () => import('@/views/product-storage/cash-requests/Detail'),
          meta: {
            title: 'Cash requests (ID: 0)',
            roles: ['general_manager', 'product_storage_manager', 'product_storage_storekeeper', 'product_storage_supervisor']
          }
        },
      ]
    },
    {
      path: 'analytics',
      component: () => import('@/views/product-storage/analytics/Layout'),
      children: [
        {
          path: '',
          name: 'product-storage-analytics-general',
          component: () => import('@/views/product-storage/analytics/General'),
          meta: {
            title: 'Analytics',
            roles: ['general_manager', 'product_storage_supervisor']
          }
        },
        {
          path: 'transfers',
          name: 'product-storage-analytics-transfers',
          component: () => import('@/views/product-storage/analytics/Transfers'),
          meta: {
            title: 'Analytics',
            roles: ['general_manager', 'product_storage_supervisor']
          }
        },
        {
          path: 'orders',
          name: 'product-storage-analytics-orders',
          component: () => import('@/views/product-storage/analytics/Orders'),
          meta: {
            title: 'Analytics',
            roles: ['general_manager', 'product_storage_supervisor']
          }
        },
      ]
    },
  ]
}